import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/facebook-ar-chatbot"
    exact
    path="/business/services/facebook-ar-chatbot"
    component={AsyncPage}
  />,
];
